/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * OrganizerRoute
 * --------------
 * Guards the /organizer tree. Two checks, in order:
 *  1. Signed in at all — otherwise to /sign-in?next=… , as PrivateRoute does.
 *  2. Holds organizer_admin — otherwise to the athlete feed (/feed).
 *
 * Note on check 2: /arcee/user/login/check does not return roles, so after a
 * reload the role comes from the copy roles.js stored at login. If localStorage
 * was cleared while the session stayed alive, roles read empty and the user is
 * sent to /feed rather than being hard-blocked — they can reach the
 * organizer surface again by signing in. Returning roles from login/check
 * would remove that edge case entirely (backend change, not done here).
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { retrieve } from '../../utils/storage_helper';
import { isOrganizerAdmin } from '../../utils/roles';

function OrganizerRoute({ children }) {
  const userData = retrieve('userData');
  const location = useLocation();

  if (!userData) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }

  if (!isOrganizerAdmin(userData)) {
    return <Navigate to="/feed" replace />;
  }

  return children;
}

export default OrganizerRoute;
